var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1301"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1430",
    opacity: 0.1,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FF865C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1551 12.9404C12.3721 13.1573 12.7238 13.1573 12.9407 12.9404C13.1576 12.7234 13.1576 12.3717 12.9407 12.1548L10.7858 9.99983L12.9407 7.84488C13.1576 7.62795 13.1576 7.27623 12.9407 7.0593C12.7238 6.84236 12.3721 6.84236 12.1551 7.0593L10.0002 9.21424L7.84521 7.05929C7.62828 6.84236 7.27656 6.84236 7.05962 7.0593C6.84269 7.27623 6.84269 7.62795 7.05962 7.84488L9.21457 9.99983L7.05962 12.1548C6.84269 12.3717 6.84269 12.7234 7.05962 12.9404C7.27656 13.1573 7.62828 13.1573 7.84521 12.9404L10.0002 10.7854L12.1551 12.9404Z",
    fill: "#FF754C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.149a313d41dfc564888ffef18dc74e65.svg";
export { ForwardRef as ReactComponent };